// API Configuration
const isDevelopment = process.env.NODE_ENV === 'development' || window.location.hostname === 'localhost';
export const API_BASE_URL = isDevelopment
  ? 'http://localhost:7860'
  : (process.env.REACT_APP_API_URL || 'https://conditional-composer-api.vercel.app');

// API endpoints
export const API_ENDPOINTS = {
  // Markets
  createMarket: `${API_BASE_URL}/api/markets`,
  getMarket: (id) => `${API_BASE_URL}/api/markets/${id}`,
  getAllMarkets: `${API_BASE_URL}/api/markets`,
  deleteMarket: (id) => `${API_BASE_URL}/api/markets/${id}`,

  // Decomposition
  decompose: (id) => `${API_BASE_URL}/api/decomposition/${id}/decompose`,
  propagate: (id) => `${API_BASE_URL}/api/decomposition/${id}/propagate`,
  getGraph: (id) => `${API_BASE_URL}/api/decomposition/${id}/graph`,
};

// Polling configuration
export const POLLING_CONFIG = {
  interval: 2000, // 2 seconds
  maxAttempts: 90, // 3 minutes max
};
